import React, { Component } from "react";
import Button from "./../components/function/button/button";
import { Route, Redirect } from "react-router";
import "./intro.css";
import ReactGA from "react-ga";
export default class Intro extends Component {
  constructor(props) {
    super(props);
    ReactGA.ga("send", "pageview", window.location.hash);
  }

  sendEmail() {
    document.getElementById("intro-form").submit();
  }

  render() {
    return (
      <div className="intro" id="Intro">
        <div className="intro-content">
          <div className="intro-content-text">
            <div className="intro-content-text-content">
              <div className="intro-conten-icon animated fadeInDown">
                <img
                  src={this.props.content.icon.websrc}
                  alt={this.props.content.icon.alt}
                />
              </div>
              <p className="intro-content-maintext montserrat fw-bold animated fadeInDown">
                {this.props.content.title}
              </p>
              <p className="intro-content-subtext montserrat fw-medium animated fadeInUp">
                {this.props.content.text}
              </p>
              <div className="intro-content-button animated fadeInUp">
                <Button
                  href={this.props.content.btn.href}
                  text={this.props.content.btn.text}
                />
              </div>
            </div>
          </div>
          <div className="intro-content-form animated fadeInRight">
            <form
              className="intro-form"
              id="intro-form"
              action="https://formspree.io/puebla@adivor.com"
              method="POST"
            >
              <div className="intro-form-group">
                <div className="intro-form-input">
                  <div className="intro-form-input-label">nombre</div>
                  <input type="text" name="Nombre" placeholder="Nombre" />
                </div>
                <div className="intro-form-input">
                  <div className="intro-form-input-label">empresa</div>
                  <input type="text" name="Empresa" placeholder="Empresa" />
                </div>
              </div>
              <div className="intro-form-input">
                <div className="intro-form-input-label">e-mail</div>
                <input type="text" name="Email" placeholder="E-Mail" />
              </div>
              <div className="intro-form-input">
                <div className="intro-form-input-label">teléfono</div>
                <input type="text" name="Teléfono" placeholder="Teléfono" />
              </div>
              <div className="intro-form-input">
                <div className="intro-form-input-label">
                  Cuéntanos sobre tu proyecto
                </div>
                <textarea rows="4" cols="50" name="Datos del proyecto" />
              </div>
              <div className="intro-form-input">
                <div className="intro-form-input-label">
                  Servicios de tu interés
                </div>
                <div className="checkboxes">
                  <div className="intro-form-input-checkbox">
                    <input
                      type="checkbox"
                      name="Web Site"
                      value="Me interesa este servicio"
                    />
                    Web Site
                  </div>
                  <div className="intro-form-input-checkbox">
                    <input
                      type="checkbox"
                      name="Ecommerce"
                      value="Me interesa este servicio"
                    />
                    Ecommerce
                  </div>
                  <div className="intro-form-input-checkbox">
                    <input
                      type="checkbox"
                      name="SEO"
                      value="Me interesa este servicio"
                    />
                    Posicionamiento Web (SEO)
                  </div>
                  <div className="intro-form-input-checkbox">
                    <input
                      type="checkbox"
                      name="Aplicaciones Móvil"
                      value="Me interesa este servicio"
                    />
                    Aplicaciones Móvil
                  </div>
                  <div className="intro-form-input-checkbox">
                    <input
                      type="checkbox"
                      name="Redes Sociales"
                      value="Me interesa este servicio"
                    />
                    Redes Sociales
                  </div>
                </div>
              </div>
              <input type="hidden" name="_next" value="/#/Gracias" />
              <div onClick={() => this.sendEmail()}>
                <div
                  style={{ marginTop: "1rem" }}
                  className="button montserrat fw-bold"
                >
                  Enviar
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sections/Intro.js